import React, { useState, useEffect } from 'react'
import { makeRequest } from '../apis/makeRequest'
import { getUsers, deleteUser } from '../apis/accountRequests'
import { useNavigate } from "react-router-dom"
import UserDetails from './UserDetails'
import { useDispatch, useSelector } from 'react-redux'
import { notificationActions } from '../actions/notificationActions'
import { Table, TableContainer, TableCell, TableHead, TableRow, Paper, TableBody, IconButton, Typography, Button, Divider, Dialog, Toolbar, DialogContent, DialogActions, DialogTitle } from '@mui/material'
import { styled } from '@mui/system'
import CreateIcon from '@mui/icons-material/Create'
import DeleteIcon from '@mui/icons-material/Delete'
import CloseIcon from '@mui/icons-material/Close'
import AddIcon from '@mui/icons-material/Add'

const HeadTableCell = styled(TableCell)(({ theme }) => ({
    backgroundColor: "#e0e0e0",
    color: theme.palette.common.black,
    fontSize: 16,
}))

const BodyTableCell = styled(TableCell)({
    backgroundColor: "#f5f5f5",
    fontSize: 15,
})

export default function Users() {

    const dispatch = useDispatch()
    const navigate = useNavigate()
    const { dynamicsId, roles, salesData } = useSelector(state => state.account)

    const [users, setUsers] = useState([])
    const [open, setOpen] = useState(false)
    const [deleteUsers, setDeleteUsers] = useState(false)
    const [borrar, setBorrar] = useState({})
    const [editUser, setEditUser] = useState({})

    useEffect(() => {
        if (users.length !== 0)
            return

        makeRequest(
            () => getUsers(),
            (res) => {
                if (!roles.includes("Administrador") && !roles.includes("Admin Ventas")) {
                    const findUser = res.data.filter(user => user.dynamicsId === dynamicsId || user.dynamicsId === salesData.dynamicsId)
                    setUsers(findUser)
                    return
                }
                setUsers(res.data)
            }
        )
    }, [users, roles, dynamicsId, salesData.dynamicsId])

    const handleClick = (event, item) => {
        setOpen(true)
        setEditUser(item)
    }

    const handleDelete = (event, item) => {
        setDeleteUsers(true)
        setBorrar(item)
    }

    const deleteData = () => {
        makeRequest(
            () => deleteUser(borrar.userName),
            (res) => {
                setDeleteUsers(false)
                dispatch(notificationActions.showSuccess({ message: `Se elimino el usuario : ${borrar.userName}` }))
                navigate('/menu')
                setUsers([])
            },
            (err) => dispatch(notificationActions.showError({ message: `Ha ocurrido un error al eliminar el usuario` }))
        )
    }


    return <>
        <Typography variant='h5' align='center'>User
            {(roles.includes("Administrador") || roles.includes("Admin Ventas")) && <Button size='small' style={{ float: 'right', height: 30 }}
                onClick={() => { setOpen(true); setEditUser({}) }}>
                <AddIcon />
            </Button>}
        </Typography>
        <Divider style={{ marginBottom: '1em' }} />
        <TableContainer component={Paper} >
            <Table size='small'>
                <TableHead>
                    <TableRow>
                        <HeadTableCell align='center'>Usuario</HeadTableCell>
                        <HeadTableCell align='center'>Roles</HeadTableCell>
                        <HeadTableCell align='center'>Email</HeadTableCell>
                        <HeadTableCell align='center'>dynamicsId</HeadTableCell>
                        {(roles.includes("Administrador") || roles.includes("Admin Ventas")) && <HeadTableCell align='center'>Editar</HeadTableCell>}
                        {(roles.includes("Administrador") || roles.includes("Admin Ventas")) && <HeadTableCell align='center'>Borrar</HeadTableCell>}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {users.map((item) => (
                        <TableRow key={item.id}>
                            <BodyTableCell align='center'>{item.userName}</BodyTableCell>
                            <BodyTableCell align='center'>{item.roles[0]}</BodyTableCell>
                            <BodyTableCell align='center'>{item.email}</BodyTableCell>
                            <BodyTableCell align='center'>{item.dynamicsId}</BodyTableCell>
                            {(roles.includes("Administrador") || roles.includes("Admin Ventas")) && <BodyTableCell align='center'>
                                    <IconButton edge='end' onClick={(event) => handleClick(event, item)} size="large"><CreateIcon /></IconButton>
                            </BodyTableCell>}
                            {(roles.includes("Administrador") || roles.includes("Admin Ventas")) && <BodyTableCell align='center'>
                                <IconButton
                                    color='inherit'
                                    onClick={(event) => handleDelete(event, item)}
                                    size="large"><DeleteIcon /></IconButton>
                            </BodyTableCell>}
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
        <Dialog maxWidth='lg' open={open} onClose={() => setOpen(false)}>
            <Toolbar variant='dense'>
                <IconButton
                    style={{ position: 'absolute', right: 10, top: 1, color: 'inherit' }}
                    onClick={() => setOpen(false)}
                    size="large">
                    <CloseIcon />
                </IconButton>
            </Toolbar>
            <Divider />
            <DialogContent>
                <UserDetails row={editUser} setter={setOpen} setters={setUsers} />
            </DialogContent>
        </Dialog>
        <Dialog open={deleteUsers} onClose={() => setDeleteUsers(false)}>
            <DialogTitle style={{ backgroundColor: 'white', color: 'black' }}>Desea eliminar el usuario: {borrar?.userName}?</DialogTitle>
            <DialogActions>
                <Button onClick={() => setDeleteUsers(false)} size='small'> Cancelar</Button>
                <Button onClick={() => deleteData()} size='small'> Borrar</Button>
            </DialogActions>
        </Dialog>
    </>;
}